import React from "react";

import Heading from "../../../typography/Heading";
import Text from "../../../typography/Text";

import "./FormHeader.css";

export default function FormHeader({
  title,
  description,
  actions,
  children,
  className = "",
  headingAs = "h2",
}) {
  if (!title && !description && !actions && !children) {
    return null;
  }

  return (
    <div className={["form-header", className].filter(Boolean).join(" ")}>
      <div className="form-header__content">
        {title && (
          <Heading as={headingAs} size="md">
            {title}
          </Heading>
        )}

        {description && (
          <Text as="p" tone="secondary" size="sm">
            {description}
          </Text>
        )}

        {children}
      </div>

      {actions && <div className="form-header__actions">{actions}</div>}
    </div>
  );
}
